/*
 * Copyright (c) 2015 - 2022 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { customSelectsInit } from "./customSelects";
import { handleFormData } from "./form";
import { loadingElement } from "./utils/loadingElement";

/**
 * @external Sortable
 */
export function menuInit() {
  var menu = document.getElementById('mega-menu-container');
  if (typeof Sortable === "function" && menu) {
    var nestedMenuItems = function nestedMenuItems(element) {
      new Sortable(element, {
        group: 'nested',
        handle: '.menu-item-handler',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        onChange: function onChange() {
          updateMenuItemIds();
        },
        onUpdate: function onUpdate() {}
      });
    };
    var serializeTreeMenu = function serializeTreeMenu(sortable) {
      var nestedQuery = '.nested-sortable';
      var identifier = 'sortableId';
      var serialized = [];
      var children = [].slice.call(sortable.children);
      for (var _i in children) {
        var nested = children[_i].querySelector(nestedQuery);
        var hasChild = nested.querySelector('.menu-item');
        var itemBody = children[_i].querySelector('.menu-item-body');
        var inputs = itemBody.querySelectorAll(".menu-item-input");
        var temp = {};
        for (var r = 0; r < inputs.length; r++) {
          temp[inputs[r].name] = inputs[r].value;
        }
        temp['id'] = children[_i].dataset[identifier];
        if (hasChild) {
          temp['children'] = nested ? serializeTreeMenu(nested) : [];
        }
        serialized.push(temp);
      }
      return serialized;
    }; // Save Menu
    var updateMenuItemIds = function updateMenuItemIds() {
      var root = document.getElementById('mega-menu-container');
      var items = root.querySelectorAll('.menu-item');
      Array.prototype.forEach.call(items, function (item, count) {
        item.dataset['sortableId'] = count;
      });
    }; // Collapse All
    var nestedSortables = [].slice.call(document.querySelectorAll('.nested-sortable'));
    for (var i = 0; i < nestedSortables.length; i++) {
      nestedMenuItems(nestedSortables[i]);
    }
    document.addEventListener("click", function (e) {
      if (e.target.matches("#save-menu")) {
        e.preventDefault();
        // const menuName = document.getElementById('menuName').value;
        var form = document.getElementById('menu-form');
        var route = form.getAttribute('action');
        var editAPIRoute = form.dataset.editRoute;
        var editPageRoute = form.dataset.editPageRoute;
        var isEditAction = form.dataset.edit === 'true';
        // let formData = new FormData();

        var root = document.getElementById('mega-menu-container');
        // console.log(serializeTreeMenu(root));
        // console.log(JSON.stringify(serializeTreeMenu(root)));
        // formData.append('name', menuName);
        // formData.append('tree', JSON.stringify(serializeTreeMenu(root)));
        // console.log(JSON.stringify(serializeTreeMenu(root)));

        var formDataArray = handleFormData(form);

        // formDataArray.push(['name', menuName]);
        formDataArray.push(['tree', JSON.stringify(serializeTreeMenu(root))]);
        var queryString = new URLSearchParams(formDataArray).toString();
        // console.log(queryString);

        // function queryStringToJSON(queryString) {
        //     if(queryString.indexOf('?') > -1){
        //         queryString = queryString.split('?')[1];
        //     }
        //     let pairs = queryString.split('&');
        //     let result = { };
        //     pairs.forEach(function(pair) {
        //         pair = pair.split('=');
        //         result[pair[0]] = decodeURIComponent(pair[1] || '');
        //     });
        //     return result;
        // }

        // let lalalal = queryStringToJSON(queryString);
        // console.log(queryStringToJSON(queryString));
        // console.log(JSON.parse(lalalal.tree));

        loadingElement.start('.menu-card');
        httpRequest({
          url: route,
          data: queryString
        }).then(function (response) {
          if (response && response.data) {
            if (response.data.success) {
              if (isEditAction) {
                form.setAttribute('action', editAPIRoute.replace("[menuId]", response.data.menu.id));
                if (form.dataset.replaceTitle) {
                  document.querySelector('.page-title').textContent = form.dataset.replaceTitle;
                }
                history.pushState(null, '', editPageRoute.replace("[menuId]", response.data.menu.id));
                form.dataset.edit = 'true';
              }
            }
          }
        })["finally"](function () {
          loadingElement.finish('.menu-card');
        });
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target.matches("#collapse-all-menu-items")) {
        var menuItemsContainer = document.getElementById('mega-menu-container');
        var menuItems = [].slice.call(menuItemsContainer.querySelectorAll('.collapse'));
        for (var _i2 = 0; _i2 < menuItems.length; _i2++) {
          var collapseMenuItem = new bootstrap.Collapse(menuItems[_i2], {
            toggle: false
          });
          collapseMenuItem.hide();
        }
      }
    });
    // Collapse Menu Item
    document.addEventListener("click", function (e) {
      if (e.target.matches(".collapse-menu-item")) {
        var menuItem = e.target.closest('.menu-item');
        var menuItemCollapse = menuItem.querySelector('.collapse');
        var collapse = new bootstrap.Collapse(menuItemCollapse);
        collapse.toggle();
      }
    });
    // Add Menu Item
    document.addEventListener("click", function (e) {
      if (e.target.matches(".add-menu-item")) {
        e.preventDefault();
        // const postSearchRoute = '/api/post/search';
        // const pageSearchRoute = '/api/page/search';
        var container = document.getElementById('mega-menu-container');
        var type = e.target.dataset.type;
        var menuItemsCount = container.querySelectorAll('.menu-item').length;
        // todo: gettext
        var pageTemplate = '<div class="col-lg-4"><label class="form-label" for="menuItemPageIdInput' + Date.now() + '">Page</label><select name="pageId" id="menuItemPageIdInput' + Date.now() + '" class="form-select menu-item-input remote-search-select" data-type="pages" data-route="' + adminConfig.routes.apiPageSearch + '" autocomplete="off"></select></div>';
        var postTemplate = '<div class="col-lg-4"><label class="form-label" for="menuItemPostIdInput' + Date.now() + '">Post</label><select name="postId" id="menuItemPostIdInput' + Date.now() + '" class="form-select menu-item-input remote-search-select" data-type="posts" data-route="' + adminConfig.routes.apiPostSearch + '" autocomplete="off"></select></div>';
        var URLTemplate = '<div class="col-lg-4"><label class="form-label" for="menuItemURLInput' + Date.now() + '">URL</label><input type="text" name="link" id="menuItemURLInput' + Date.now() + '" class="form-control menu-item-input"></div>';
        var template = '<div data-sortable-id="' + menuItemsCount + '" class="menu-item"><div class="menu-item-body card p-1 mb-1"><div class="menu-item-header d-flex justify-content-between align-items-center"><div class="d-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" class="icon menu-item-handler me-2" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M11 11V5.828L9.172 7.657 7.757 6.243 12 2l4.243 4.243-1.415 1.414L13 5.828V11h5.172l-1.829-1.828 1.414-1.415L22 12l-4.243 4.243-1.414-1.415L18.172 13H13v5.172l1.828-1.829 1.415 1.414L12 22l-4.243-4.243 1.415-1.414L11 18.172V13H5.828l1.829 1.828-1.414 1.415L2 12l4.243-4.243 1.414 1.415L5.828 11z"/></svg><span class="menu-item-title">-</span></div><div><button type="button" class="btn btn-icon collapse-menu-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="icon" fill="currentColor"><path d="M19 9h-2.58l3.29-3.29a1 1 0 1 0-1.42-1.42L15 7.57V5a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2z"/><path d="M10 13H5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.42V19a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"/></svg></button><button type="button" class="btn btn-icon delete-menu-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="icon" fill="currentColor"><path d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-4.586 6l1.768 1.768-1.414 1.414L12 15.414l-1.768 1.768-1.414-1.414L10.586 14l-1.768-1.768 1.414-1.414L12 12.586l1.768-1.768 1.414 1.414L13.414 14zM9 4v2h6V4H9z"/></svg></button></div></div><div class="collapse mt-3 show"><div class="row"><div class="col-lg-4"><label class="form-label" for="menuItemTitleInput' + Date.now() + '">Title</label><input type="text" name="title" id="menuItemTitleInput' + Date.now() + '" class="form-control menu-item-input menu-item-title-input"></div>' + (type === 'page' ? pageTemplate : '') + (type === 'post' ? postTemplate : '') + (type === 'link' ? URLTemplate : '') + '<div class="col-lg-4"><label class="form-label" for="menuItemClassInput' + Date.now() + '">Class</label><input class="form-control menu-item-input" type="text" name="class" id="menuItemClassInput' + Date.now() + '"></div></div></div></div><div class="nested-sortable"></div></div>';
        container.insertAdjacentHTML('beforeend', template);
        updateMenuItemIds();
        var items = container.querySelectorAll(".menu-item");
        var lastChildEl = items[items.length - 1];
        var nmi = lastChildEl.querySelector('.nested-sortable');
        // let lastChildSearchField = lastChildEl.querySelector('.remote-search-select');
        // console.info(lastChildEl)
        customSelectsInit(lastChildEl);
        // lastChildSearchField ? KAAGlobalObj.superMegaSearch(lastChildSearchField.id) : null;
        nestedMenuItems(nmi);
      }
    });
    // Change Title
    document.addEventListener("keyup", function (e) {
      if (e.target.matches(".menu-item-title-input")) {
        var menuItem = e.target.closest('.menu-item');
        menuItem.querySelector('.menu-item-title').textContent = e.target.value;
      }
    });
    // Delete Menu Item
    document.addEventListener("click", function (e) {
      if (e.target.matches(".delete-menu-item")) {
        e.preventDefault();
        var menuItem = e.target.closest('.menu-item');
        menuItem.remove();
        updateMenuItemIds();
      }
    });
  }
}